import styles from './style.module.scss';
import { Col, Row, Spin, Table, Typography } from 'antd';
import useInvoicesConversionRateVillagePages from '../useInvoicesConversionRateVillagePages';
import LineChart from '../../../charts/lineChart';
import PrintFilterText from '../../printFiiterText';

const Print = ({
  allReports = false,
  allReportsData,
  isAllReports,
  isMain,
}) => {
  const {
    data,
    columns,
    summary,
    loading,
    format,
    title,
    searchParams,
    filters,
  } = useInvoicesConversionRateVillagePages(true, allReportsData, isAllReports);
  if (!isMain) {
    localStorage.setItem('auth_token', searchParams.get('token'));
  }

  const searchParamsObj = Object.fromEntries([...searchParams]);
  const searchParamsObjKeys = Object.keys(searchParamsObj);
  const availableFilters = filters.filter((i) =>
    searchParamsObjKeys.includes(i.name),
  );

  return (
    <>
      <div className={styles.container}>
        <Spin spinning={loading}>
          {!allReports && (
            <Row className={styles.titleSection} justify={'center'}>
              <Col>
                <Typography.Title level={3}>{title}</Typography.Title>
              </Col>
              <PrintFilterText
                availableFilters={availableFilters}
                searchParams={searchParams}
              />
            </Row>
          )}
          {allReports && (
            <Row className={styles.titleSection} justify={'center'}>
              <Col>
                <Typography.Title level={3}>
                  Conversion Rate vs LY
                </Typography.Title>
              </Col>
            </Row>
          )}
          <br />
          <Row>
            <Col span={24}>
              <Table
                loading={loading}
                columns={columns}
                dataSource={data.tableData}
                pagination={{
                  pageSize: 10000,
                  position: ['bottomCenter'],
                  hideOnSinglePage: true,
                  showSizeChanger: false,
                }}
                bordered
                scroll={{ x: 500 }}
                summary={summary}
              />
            </Col>
            <Col span={12} className={'chartColl'}>
              <LineChart
                data={data.lineChartData}
                tableData={data.tableData}
                colors={['#61cdbb', '#f47560']}
                format={format}
              />
              <br />
              <div>
                <LineChart
                  data={data.lineChartData2}
                  tableData={data.tableData}
                  colors={['#61cdbb', '#f47560']}
                  format={format}
                />
              </div>
            </Col>
          </Row>
        </Spin>
      </div>
    </>
  );
};

export default Print;
